module.exports = __webpack_public_path__ + "img/b_selected.38274581.png";